package dev.akshaychordiya.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobwebx.markdown.markdown
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Div

/**
 * For standalone Markdown pages like /about - prose styling without the date and back-link chrome an article gets.
 * Opt in from front matter with `layout: .components.layouts.ProseLayout`.
 */
@InitRoute
fun initProseLayout(ctx: InitRouteContext) {
    val title = ctx.markdown!!.frontMatter["title"]?.firstOrNull()
    require(title != null) { "Markdown pages must set \"title\" in their front matter" }
    ctx.data.add(PageLayoutData(title))
}

@Composable
@Layout(".components.layouts.PageLayout")
fun ProseLayout(content: @Composable () -> Unit) {
    Div(ProseStyle.toModifier().fillMaxWidth().margin(top = 1.5.cssRem).toAttrs()) {
        content()
    }
}
